<div sizeClass="XL: wrap">
    <div class="w-1"
         *ifSize="'XL'"></div>
    @if (content) {
    <div class="w-10 w-12-s w-12-m m-t-15 m-t-10-s p-b-6 center">
        @if (checkoutData) {
        <!-- header -->
        <span class="icon-tick col-w icon-medium inline-flex b-radius-max bg-col-3 p-a-1"></span>
        <h1 class="m-t wrap-s"
            sizeClass="S:h3, !S:h2">{{'Thank you for your order' | translate}}</h1>
        <p class="m-t p1 w-6 w-12-s w-8-m wrap-s">
            {{"We’ve sent an email to" | translate}} <span class="s2"
                  [sizeClass]="'S: overflow-wrap'">{{checkoutData.customer.email}}</span> {{"with your
            order confirmation and receipt. If the email hasn’t arrived within a few minutes, please check your
            spam folder."
            | translate
            }}
        </p>
        <p class="m-t p1 wrap-s">{{'Your order number is' | translate }}:&nbsp;<span class="s2"
                  sl-orderid>{{checkoutData.number}}</span></p>
        <!-- new account / redirect after submit -->
        @if (canRegister && !status.success) {
        <div class="m-t-8 m-t-5-s w-12 p-a bg-col-53 left-s p-l-20 p-r-20 p-l-0-s p-r-0-s">
            <form #form="ngForm"
                  method="POST"
                  class="flex-column"
                  [sizeClass]="'S: flex-start wrap, !S: flex-middle'">
                <p class="h3"
                   *iCms="'signUpTitle' of content"></p>
                <p class="m-t"
                   *iCms="'signUpDescription' of content; content: 'html'"
                   [sizeClass]="'SM: p3, XL: p2'"></p>
                @if (content.signUpElements?.length) {
                <p class="m-t m-t-2-s flex flex-column-s">
                    @for (element of content.signUpElements; track $index; let isLast = $last) {
                    <span class="p2 flex flex-middle m-t-2-s"
                          [class.m-r-10]="!isLast"> <span class="icon-tick m-r-1 col-3 inline-flex"></span><span
                              *iCms="'title' of element"></span></span>
                    }
                </p>
                }
                <div class="flex flex-justify-start flex-wrap m-t w-6 w-10-m w-12-s"
                     [style.max-width]="'650px'">
                    <input-wrap class="flex-grow password-input _password-input pos-relative w-12-s p-r-2 p-r-0-s">
                        <input class="input"
                               type="password"
                               name="password"
                               [(ngModel)]="registrationData.password"
                               (ngModelChange)="updatePlaceholder()"
                               required
                               sl-input="password" />
                        <!-- custom label, can't use muiInput -->
                        @if (displayPlaceholder) {
                        <label class="_label p1 col-12 pe-none">{{'Enter a password' | translate}}</label>
                        }
                    </input-wrap>
                    <action (click)="register()"
                            class="button w-12-s m-t-2-s"
                            [status]="status"
                            sl-button="account.create">
                        <span>{{'Create account' | translate}}</span>
                    </action>
                    <p class="p3 m-t-2 w-12 left"
                       *iCms="'signUpCopy' of content"></p>
                    <result class="block p-3 m-t-2 w-12 left"
                            [status]="status"></result>
                </div>
            </form>
        </div>
        }
        <div class="wrap-s wrap-m"
             [sizeClass]="'!S: p-b-8 b-b b-col-53 m-b-8'">
            <!-- print -->
            <div class="w-12 m-t-8 m-t-5-s left p-b m-b p-b-2-s m-b-2-s b-b b-col-53">
                <button (click)="print()"
                        class="p2 flex flex-middle">
                    <span class="icon-print m-r-1 col-1 inline-flex icon-medium"></span>
                    {{'Print' | translate}}
                </button>
            </div>
            <!-- first column -->
            <div class="p-t left p2"
                 [sizeClass]="'!S: w-6 p-r-10 b-r b-col-53'">
                <p class="p1 flex flex-middle">
                    <span class="icon-home m-r-2 inline-flex icon-medium"></span>
                    {{'Shipping Address' | translate}}
                </p>
                <short-address class="block m-t-3"
                               [color]="'col-1'"
                               [address]="checkoutData.shipping"
                               [zipCodeBelow]="true"></short-address>
                @if (markers?.length) {
                <div class="overflow-hidden _mapContainer">
                    <shell></shell>
                    <google-map class="fill"
                                [markers]="markers"
                                [centerFirstMarker]="true"
                                [options]="{disableDefaultUI: true, streetViewControl: false, zoom: 16}">
                    </google-map>
                </div>
                }
                <div class="m-t m-t-9-s p-t-8 p-t-5-s b-t b-col-53">
                    <div class="p-t p-a-4-s left"
                         [sizeClass]="'!S: w-6 p-r-8'">
                        <p class="p1 flex flex-middle">
                            <span class="icon-delivery m-r-2 inline-flex icon-medium"></span>
                            {{'Shipping method' | translate}}
                        </p>
                        <p class="p2 m-t">{{checkoutData.shipping_method.description}}</p>
                    </div>
                    <div class="left"
                         [sizeClass]="'!S: w-6 p-l-8 p-t p-b b-l b-col-53, S: m-t-5 p-a p-t-9 b-t b-col-53'"
                         [style.min-height]="client.isS ? 'unset' : '250px'">
                        <p class="p1 flex flex-middle">
                            <span class="icon-card m-r-2 inline-flex icon-medium"></span>
                            {{'Payment Info' | translate}}
                        </p>
                        <short-address class="block m-t-3"
                                       [color]="'col-1'"
                                       [address]="checkoutData.billing"
                                       [zipCodeBelow]="true"></short-address>
                        <p class="p2 m-t--2">{{checkoutData.payment_method.description}}</p>
                    </div>
                </div>
                <ng-container *ifSize="'!S'">
                    <ng-container *ngTemplateOutlet="returnPolicyTpl"></ng-container>
                </ng-container>
            </div>
            <!-- second column -->
            <div class="left b-col-53"
                 [sizeClass]="'!S: w-6 p-t p-l-10 p-b-8 b-l, S: m-t-5 p-t-9 b-t'"
                 [style.margin-left]="client.isS ? '0px' : '-1px'">
                <!-- columns border depends which oneis longer -->
                <h3 class="h3">{{'Order Summary' | translate}}</h3>
                <ecologi-banner-block class="w-12"
                                      [numberOfTrees]="ecologiTreeNumber"></ecologi-banner-block>
                <mention-me-wrapper *ifStore="['uk', 'us', 'ca', 'au']"
                                    mmid="mm8424c5bb"
                                    place="referreroffer"
                                    situation="postpurchase"
                                    [checkoutSuccessData]="checkoutData"></mention-me-wrapper>
                @for (product of checkoutData.items; track $index; let isFirst = $first; let isLast = $last) {
                <checkout-success-item class="w-12 p-b-2 m-b-2 b-b b-col-53"
                                       [class.b-b]="!isLast || !client.isS"
                                       [class.m-t]="isFirst"
                                       [class.m-t-3-s]="isFirst"
                                       [modelId]="product.product_id"
                                       [item]="product">
                </checkout-success-item>
                }
                <!-- totals -->
                <checkout-success-totals-section [totals]="checkoutData.totals"></checkout-success-totals-section>
                <!-- contact -->
                @if (content.contactTel || content.contactEmail) {
                <p class="w-12 m-t-8 m-t-7-s p-t-2 b-col-53 c1 col-11"
                   [class.b-t]="!client.isS">{{'Made a mistake?' | translate}}</p>
                <p class="h3 p-t-2 p-t-1-s">{{'Get in touch' | translate}}</p>
                }
                @if (content.contactTel) {
                <a class="button-1 w-12 m-t m-t-2-s"
                   [attr.href]="'tel:' + this.content.contactTel">
                    <span class="button__body flex flex-middle">
                        <span class="icon-phone-inline m-r-1 inline-flex icon-medium"></span>
                        <span *iCms="'contactTel' of content"></span>
                    </span>
                </a>
                }
                @if (content.contactEmail) {
                <a class="button-1 w-12 m-t-2"
                   [attr.href]="'mailto:' + this.content.contactEmail">
                    <span class="button__body flex flex-middle">
                        <span class="icon-email m-r-1 inline-flex icon-medium"></span>
                        <span>{{'Email Us' | translate}}</span>
                    </span>
                </a>
                }
            </div>
            <ng-container *ifSize="'S'">
                <ng-container *ngTemplateOutlet="returnPolicyTpl"></ng-container>
            </ng-container>
        </div>
        }
        <!-- back button -->
        <a routerLink="/"
           class="button m-t-8 m-t-5-s"
           sl-button="back">
            <span class="button__body">
                {{'Continue Shopping' | translate}}</span>
        </a>
        <!-- bottom components -->
        <icms-outlet *ifSize="'!S'"
                     [components]=" content.bottomComponents">
        </icms-outlet>
    </div>
    }
    <div class="w-1"
         *ifSize="'XL'"></div>
</div>

<!-- bottom components -->
<icms-outlet *ifSize="'S'"
             [components]=" content?.bottomComponents">
</icms-outlet>

<ng-template #returnPolicyTpl>
    @if (content.returnPolicyTitle && content.returnPolicyContent) {
    <div class="b-col-53 left"
         [sizeClass]="'!S: m-t p-t-8 b-t p-b-8, S: m-t-5 p-a b-a'">
        <h3 class="h3"
            *iCms="'returnPolicyTitle' of content">
        </h3>
        <!-- remove class text / wrong styleing -->
        <p class="p2 m-t-2"
           *iCms="'returnPolicyContent' of content; content: 'html'"
           [class.text]="false"></p>
    </div>
    }
</ng-template>
